/**
 * Indian Currency Number Formatting Helper
 * Formats price numbers into Indian grouping format (e.g. 1,00,000 instead of 100,000; 1,00,00,000 for 1 Crore).
 */
(() => {
  function formatIndianInteger(intStr) {
    if (intStr.length <= 3) return intStr;
    const last3 = intStr.slice(-3);
    const remaining = intStr.slice(0, -3);
    return remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
  }

  function convertPriceText(text) {
    if (!text || typeof text !== 'string') return text;
    // Match either:
    // 1) With currency symbol/code (e.g. ₹100000 or ₹100,000 or Rs. 100,000.00)
    // 2) Or with comma-separated grouping (e.g. 100,000.00 or 100,000)
    return text.replace(/([₹$€£]|Rs\.?|INR)\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d{2})?/gi, (match, prefix, numPart, decimalPart) => {
      const rawInt = numPart.replace(/,/g, '');
      if (rawInt.length < 4) return match;
      const formattedInt = formatIndianInteger(rawInt);
      const space = match.includes(prefix + ' ') ? ' ' : '';
      return prefix + space + formattedInt + (decimalPart || '');
    }).replace(/\b(\d{1,3}(?:,\d{3})+)(\.\d{2})?\b/g, (match, numPart, decimalPart) => {
      const rawInt = numPart.replace(/,/g, '');
      if (rawInt.length < 4) return match;
      const formattedInt = formatIndianInteger(rawInt);
      return formattedInt + (decimalPart || '');
    });
  }

  function formatPriceElements(root = document) {
    const selectors = [
      '.price',
      '.price-item',
      '.compare-at-price',
      '.pag-product-card-price',
      '.pag-product-card-price-current',
      '.pag-product-card-price-was',
      '.cart-items__price',
      '.cart-totals__original-value',
      '.cart-totals__total-value',
      '.cart-discounts__value',
      '[data-variant-price]',
      'text-component',
      'price-per-item'
    ];

    const elements = root.querySelectorAll(selectors.join(','));
    elements.forEach((el) => {
      if (el.tagName === 'INPUT' || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
      
      for (const node of el.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.trim()) {
          const updated = convertPriceText(node.nodeValue);
          if (updated !== node.nodeValue) {
            node.nodeValue = updated;
          }
        }
      }
    });
  }

  // Hook Shopify.formatMoney if defined
  function hookShopifyFormatMoney() {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && !window.Shopify._indianFormatHooked) {
      const originalFormat = window.Shopify.formatMoney;
      window.Shopify.formatMoney = function(cents, format) {
        const result = originalFormat(cents, format);
        return convertPriceText(result);
      };
      window.Shopify._indianFormatHooked = true;
    }
  }

  // Observe DOM updates for AJAX cart, variant change, section render
  let debounceTimer = null;
  const observer = new MutationObserver((mutations) => {
    let shouldFormat = false;
    for (const m of mutations) {
      if (m.type === 'childList' && m.addedNodes.length > 0) {
        shouldFormat = true;
        break;
      } else if (m.type === 'characterData') {
        shouldFormat = true;
        break;
      }
    }
    if (shouldFormat) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        formatPriceElements();
      }, 30);
    }
  });

  function init() {
    hookShopifyFormatMoney();
    formatPriceElements();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => formatPriceElements());
  document.addEventListener('cart:updated', () => formatPriceElements());
  window.addEventListener('load', () => {
    hookShopifyFormatMoney();
    formatPriceElements();
  });
})();
